import { useQueryClient } from '@tanstack/react-query';

import { DEFAULT_TARGET_CHAIN, tokensInfo } from '@shared/constants/wallets';
import { useWriteContractExecutor } from '@shared/helpers/web3/useWriteContractExecutor';

import { getQueryKey } from '../../../model/web3Raffle/api/config';
import { RAFFLE_CONTRACT } from '../contract';
import type { Web3RaffleSupportedToken } from '../supportedTokens';

type Props = {
  amount: number;
  tokenName: Web3RaffleSupportedToken;
  ticketPrice: number;
};

export const useBuyTickets = () => {
  const queryClient = useQueryClient();

  const { execute } = useWriteContractExecutor();

  const buyTickets = async ({ amount, tokenName, ticketPrice }: Props) => {
    const { decimals, contractsAddresses } = tokensInfo[tokenName];

    return execute({
      props: {
        abi: RAFFLE_CONTRACT.abi,
        contractAddress: RAFFLE_CONTRACT.address,
        functionName: 'buyTicket',
        chainId: DEFAULT_TARGET_CHAIN.id,
        args: [BigInt(amount), tokenName === 'SQR'],
        approve: {
          amount: Number.MAX_SAFE_INTEGER,
          amountToCheck: amount * ticketPrice,
          tokenAddress: contractsAddresses.token,
          tokenDecimals: decimals,
        },
      },
      options: {
        toastMessage: 'Processing your ticket purchase...',
        onSuccess: () => {
          void queryClient.invalidateQueries({
            queryKey: getQueryKey(),
          });
        },
      },
    });
  };

  return { buyTickets };
};
